import type { ThemeDefinition } from "./types";
import { FOAM, hexToSrgb, hexToLinear } from "./palette";

export const foam: ThemeDefinition = {
  label: "Foam",
  className: "theme-foam",
  bg: FOAM.bg,
  text: FOAM.text,
  textMuted: `color-mix(in srgb, ${FOAM.text} 60%, transparent)`,
  accent: FOAM.accent,
  glassRgb: "232,240,236",
  border: "rgba(255,255,255,0.50)",
  borderHighlight: "rgba(255,255,255,0.50)",
  separator: `color-mix(in srgb, ${FOAM.text} 30%, transparent)`,
  selection: FOAM.text,
  selectionText: "#ffffff",
  gridColor: "#c0d8cc",
  noiseOpacity: "0.03",
  gridOpacity: "0.7",
  textShadow: "0 -1px 0px rgba(255,255,255,0.4), 0 10px 0px rgba(20,40,30,0.15)",
  gpuClear: hexToSrgb(FOAM.bg),
  gpuGridLine: hexToLinear("#90b8a4"),
  gpuGridAlpha: 0.7,
  gpuAxisX: hexToLinear(FOAM.accent),
  gpuAxisZ: hexToLinear(FOAM.text),
  axisXColor: FOAM.accent,
  axisZColor: FOAM.text,
  font: '"Space Grotesk", sans-serif',
};
